export const API_ENDPOINTS = {
  AUTH: {
    SIGN_IN: "/auth/sign-in",
    SIGN_UP: "/auth/sign-up",
    SIGN_OUT: "/auth/sign-out",
    REFRESH_TOKEN: "/auth/refresh-token",
  },
  AUTH_BUSINESS: {
    LOG_IN: "/business/auth/login",
    LOG_IN_TEST: "/business/auth/test/login",
    APP_LOG_IN: "/business/auth/app/login",
    APP_LOG_IN_AUTO: "/business/auth/app/auto/login",
    SIGN_UP: "/business/auth/sign-up",
    CHECK_BUSINESS_NUMBER: "/business/auth/business-number/check",
    SIGN_OUT: "/business/auth/sign-out",
    REFRESH_TOKEN: "/business/auth/refresh",
    SIGN_IN_SELECTLIST: "/business/auth/sign-up/form",
    WITHDRAWAL: "/business/auth/withdrawal",
    USER_INFO: "/business/auth/userInfo",
    ACTIVE_ALARM_READ: "/business/auth/active/alarm/read",
    HAS_COMPANY: "/business/auth/hasCompany",
  },
  AUTH_CUSTOMER: {
    LOG_IN: "/user/auth/login",
    LOG_IN_TEST: "/user/auth/test/login",
    APP_LOG_IN: "/user/auth/app/login",
    APP_LOG_IN_AUTO: "/user/auth/app/auto/login",
    SIGN_UP: "/user/auth/sign-up",
    SIGN_OUT: "/user/auth/sign-out",
    REFRESH_TOKEN: "/user/auth/refresh",
    SIGN_IN_SELECTLIST: "/user/auth/sign-up/form",
    CREATE_PET_FORM: "/user/auth/create-pet-form",
    PET_CREATE: "/user/auth/pet-create",
    WITHDRAWAL: "/user/auth/withdrawal",
  },
  OAUTH: {
    APPLE_CUSTOMER: "/oauth/apple-customer",
    APPLE_BUSINESS: "/oauth/apple-business",
  },
  USER: {
    PROFILE: "/user/profile",
    UPDATE_PROFILE: "/user/profile/update",
  },
  PAYMENT: {
    BUY_COIN: "/payment/coin/buy",
    COIN_HISTORY: "/payment/coin/history",
    AUTO_PAYMENT: "/payment/auto",
  },
  TOSS_PAYMENT: {
    PRE_ORDER: "/payment/toss/pre-order",
    ORDER_CONFIRM: "/payment/toss/order-confirm",
  },
  TICKET_PAYMENT: {
    PRE_ORDER: "/user/main/ticket/pre-order",
    ORDER_CONFIRM: "/user/main/ticket/order-confirm",
  },
  RESERVATION: {
    CREATE: "/reservation/create",
    LIST: "/reservation/list",
    DETAIL: "/reservation/detail",
    CANCEL: "/reservation/cancel",
    PRODUCT_LIST: "/user/reserve/product-list",
    FORMS: "/user/reserve/forms",
    CALCULATE_COIN: "/user/reserve/calculateCoin",
    GROOMING_TIME_CHECK: "/user/reserve/groomingTimeCheck",
    RESERVE: "/user/reserve",
    UPDATE: "/user/reserve/update",
    CANCEL_USER: "/user/reserve/cancel",
    HAS_BALANCE_COIN: "/user/reserve/hasBalanceCoin",
    UPDATE_TEMP: "/user/reserve/update-temp",
    CONTRACT: "/user/reserve/contract",
    GET_CONTRACT: "/user/reserve/contract",
    COMPANY_LIST: "/user/reserve/company-list",
    NOTICE_READ: "/user/reserve/notice-read",
    RESERVABLE_DATE: "/user/reserve/reservable/date",
    RESERVABLE_TIME: "/user/reserve/reservable/time",
    PET_LIST: "/user/reserve/pet-list",
    CAPACITY_CHECK: "/user/reserve/capacity-check",
  },
  MAIN: {
    PETLIST: "/user/pet/pet-list",
    PETCALENDARLIST: "/user/calendar",
    PETSCHEDULELIST: "/user/main/schedule-list",
    USER_ASSIGN_AREA_LIST: "/user/main/user-region-list",
    BANNER_LIST: "/user/main/banner-list",
    BANNER_IMPRESSIONS: "/user/main/banner-impressions",
    BANNER_CLICK: "/user/main/banner-click",
    USER_REGION_SAVE: "/user/main/user-region-save",
    USER_REGION_DELETE: "/user/main/user-region-delete",
    COMPANY_LIST: "/user/main/company-list",
    COMPANY_MAP_LIST: "/user/main/company-map-list",
    COMPANY_SEARCH: "/user/main/company-search",
    COMPANY_DETAIL: "/user/main/company-detail",
    COMPANY_TICKET_LIST: "/user/main/company-ticket-list",
    NEW_NOTICE: "/user/main/new-notice",
    GUARDIAN_INVITE_RESPONSE: "/user/main/guardian/invite",
  },
  USERNOTICE: {
    NOTICE_SENDER_LIST: "/user/notice/sender-list",
    NOTICE_RECIPIENT_LIST: "/user/notice/recipient-list",
    NEWNOTICELIST: "/user/notice/new-list",
    NOTICE_READ: "/user/notice",
    NOTICE_SEND_SUBDATA: "/user/notice/send-user-notice-forms",
    SEND: "/user/notice",
    REPLY_SAVE: "/user/notice/reply-save",
    REPLY: "/user/notice/reply",
    LIST: "/user/notice/list",
    READ_ALL: "/user/notice/read-all",
    HAS_NEW_REPLY: "/user/notice/has/new-reply",
  },
  USER_CALENDAR: {
    CALENDAR_LIST: "/user/calendar",
    CALENDAR_PRODUCT_COUNT: "/user/calendar/product-count",
    CALENDAR_PET_LIST: "/user/calendar/pet-list",
    CALENDAR_SCHEDULE_LIST: "/user/calendar/day-schedule-list",
  },
  USER_MYPAGE: {
    USER_MYPAGE_MAIN: "/user/mypage",
    USER_MYPAGE_MEMBER_CODE: "/user/mypage/member-code",
    USER_MYPAGE_INFO: "/user/mypage/info",
    USER_INFO: "/user/mypage/info",
    UPDATE_INFO: "/user/mypage/update-info",
    PET_INFO: "/user/mypage/pet-info",
    PET_UPDATE: "/user/mypage/pet-update",
    PET_DELETE_REASON: "/user/mypage/pet-delete-reason",
    PET_DELETE: "/user/mypage/pet-delete",
    USER_MYPAGE_ALARM_INFO: "/user/mypage/alarm-info",
    USER_MYPAGE_ALARM_INFO_UPDATE: "/user/mypage/update-alarm",
    USER_MYPAGE_CONTRACT_LIST: "/user/mypage/contract-list",
    USER_MYPAGE_CONTRACT_DETAIL: "/user/mypage/contract-detail",
    USER_MYPAGE_PAYMENT: "/user/mypage/payment",
    USER_MYPAGE_SETTING: "/user/mypage/setting",
    PET_CREATE: "/user/mypage/pet-create",
    COIN_PRODUCT_LIST: "/user/mypage/coin/product-list",
    COIN_PRE_ORDER: "/user/mypage/coin/pre-order",
    TICKET_LIST: "/user/mypage/ticket-list",
    TICKET_DETAIL: "/user/mypage/ticket-detail",
    TICKET_REFUND: "/user/mypage/ticket/refund",
    GUARDIAN_LIST: "/user/mypage/guardian",
    GUARDIAN_INVITE: "/user/mypage/guardian/invite",
    USAGE_HISTORY: "/user/mypage/usage-history",
    USAGE_DETAIL: "/user/mypage/usage-detail",
  },
  USER_PHOTO: {
    ALBUM: "/user/photo/album",
    DETAIL: "/user/photo",
  },
  BUSINESS_MYPAGE: {
    MAIN: "/business/mypage",
    INFO: "/business/mypage/info",
    UPDATE_INFO: "/business/mypage/update-info",
    ALARM_INFO: "/business/mypage/alarm-info",
    UPDATE_ALARM: "/business/mypage/update-alarm",
    CONTRACT_LIST: "/business/mypage/contract-list",
    CONTRACT_DETAIL: "/business/mypage/contract-detail",
    PAYMENT: "/business/mypage/payment",
    BUSINESS_TIME: "/business/mypage/business-time",
    HOLIDAY: "/business/mypage/holiday",
    RESERVE_DEADLINE: "/business/mypage/reserve-deadline",
    // 기존 엔드포인트들 추가
    BUSINESS_MYPAGE_MAIN: "/business/mypage",
    MENU: "/business/mypage/menu",
    BUSINESS_MYPAGE_INFO: "/business/mypage/info",
    BUSINESS_MYPAGE_INFO_UPDATE: "/business/mypage/update-info",
    BUSINESS_MYPAGE_COMPANY_INFO: "/business/mypage/company-info",
    BUSINESS_MYPAGE_COMPANY_INFO_UPDATE: "/business/mypage/company-info-update",
    BUSINESS_MYPAGE_ALARM_INFO: "/business/mypage/alarm-info",
    BUSINESS_MYPAGE_ALARM_INFO_UPDATE: "/business/mypage/update-alarm",
    BUSINESS_MYPAGE_COMPANY_MEMBER: "/business/mypage/company-member",
    BUSINESS_MYPAGE_COMPANY_MEMBER_JOIN: "/business/mypage/company-member-join",
    BUSINESS_MYPAGE_COMPANY_MEMBER_INFO: "/business/mypage/company-member-info",
    BUSINESS_MYPAGE_COMPANY_MEMBER_PERMISSIONS:
      "/business/mypage/company-member-permissions",
    BUSINESS_MYPAGE_COMPANY_MEMBER_DELETE:
      "/business/mypage/company-member-delete",
    BUSINESS_MYPAGE_PRODUCT_LIST: "/business/mypage/product-list",
    BUSINESS_MYPAGE_PRODUCT_UPDATE: "/business/mypage/product-update",
    BUSINESS_MYPAGE_SERVICE_PROVIDE_LIST:
      "/business/mypage/service-provide-list",
    BUSINESS_MYPAGE_CUSTOMER_LIST: "/business/mypage/customer-list",
    BUSINESS_MYPAGE_CUSTOMER_DETAIL: "/business/mypage/customer-detail",
    BUSINESS_MYPAGE_CUSTOMER_TICKET_LIST:
      "/business/mypage/customer/ticket-list",
    BUSINESS_MYPAGE_CUSTOMER_TICKET_USAGE:
      "/business/mypage/customer/ticket-usage",
    BUSINESS_MYPAGE_PET_MEMO: "/business/mypage/customer/pet-memo",
    BUSINESS_MYPAGE_CONTRACT_LIST: "/business/mypage/contract-list",
    BUSINESS_MYPAGE_CONTRACT_DETAIL: "/business/mypage/contract-detail",
    BUSINESS_MYPAGE_SERVICE_STATS: "/business/mypage/service-stats",
    BUSINESS_MYPAGE_SETTLEMENT_INFO: "/business/mypage/settlement-info",
    DISCONNECT_COMPANY: "/business/mypage/disconnect-company",
    TICKET_LIST: "/business/mypage/ticket-list",
    TICKET: "/business/mypage/ticket",
    TICKET_DETAIL: "/business/mypage/ticket-detail",
    TICKET_ORDER: "/business/mypage/ticket-order",
    SEARCH_USER: "/business/mypage/search-user",
    CONTRACT_RECIPIENT: "/business/mypage/contract-recipient",
    RESOLVE_MEMBER_CODE: "/business/mypage/member-code/resolve",
    MANUAL_TICKET: "/business/mypage/manual-ticket",
    TICKET_ISSUE_LIST: "/business/mypage/ticket/issue/list",
    TICKET_ISSUE_SUMMARY: "/business/mypage/ticket/issue/summary",
    TICKET_ISSUE_DETAIL: "/business/mypage/ticket/issue/detail",
    TICKET_ISSUE_EXPIRED: "/business/mypage/ticket/issue/expired",
    TICKET_ISSUE_STATUS: "/business/mypage/ticket/issue/status",
    USAGE_HISTORY: "/business/mypage/usage-history",
    COMPANY_ACTIVE: "/business/mypage/company/active",
    DUPLE_RESERVE_SETTING: "/business/mypage/duple-reserve-setting",
  },

  // 레거시(HIST_CONTRACT) + 신규(HIST_CONTRACT_REQUEST) 통합 계약 내역
  CONTRACT_HISTORY: {
    COMPANY: "/contract-history/company",
    USER: "/contract-history/user",
  },

  // 신규 e-sign 요청 상세 (REQUEST 출처 — source 분기용)
  CONTRACT_REQUEST: {
    BUSINESS_DETAIL: "/business/contract/request", // GET {requestSeq}
    USER_DETAIL: "/user/contract/request", // GET {requestSeq}
  },
  BUSINESS_MAIN: {
    HOME_SUMMARY: "/business/main/home-summary",
    ATTEND_LIST: "/business/main/attend-list",
    UPDATE_ATTEND: "/business/main/update-attend",
    CALENDAR: "/business/calendar",
  },
  BUSINESS_RESERVE: {
    RESERV_TYPE_LIST: "/business/reserve/reservType-list",
    LIST: "/business/reserve/list",
    DETAIL: "/business/reserve",
    UPDATE: "/business/reserve/update",
    CAPACITY_CHECK: "/business/reserve/capacity-check",
  },
  BUSINESS_MANUAL_RESERVE: {
    TICKET_HOLDER_LIST: "/business/manual/reserve/ticket-holder-list",
    TICKET_LIST: "/business/manual/reserve/ticket-list",
    PET_LIST: "/business/manual/reserve/pet-list",
    RESERVABLE_DATE: "/business/manual/reserve/reservable/date",
    RESERVABLE_TIME: "/business/manual/reserve/reservable/time",
    CONTRACT: "/business/manual/reserve/contract",
    RESERVE: "/business/manual/reserve",
    CALENDAR: "/business/manual/reserve/calendar",
  },
  BUSINESS_NOTICE: {
    NOTICE_SENDER_LIST: "/business/notice/sender-list",
    NOTICE_RECIPIENT_LIST: "/business/notice/recipient-list",
    NOTICE_SAVE_LIST: "/business/notice/save-list",
    NOTICE_TEMP_LIST: "/business/notice/temp-list",
    NOTICE_SELECT_LIST: "/business/notice/send-forms",
    NOTICE_SEND: "/business/notice/send-notice",
    NOTICE_EDIT: "/business/notice/edit-notice",
    NOTICE_TEMP_DELETE: "/business/notice/temp-delete",
    NEWNOTICELIST: "/business/notice/new-list",
    NOTICE_READ: "/business/notice", // Used for GET detail
    NOTICE_DETAIL: "/business/notice/detail",
    NOTICE_SEND_SUBDATA: "/business/notice/send-forms",
    SEND: "/business/notice", // Added for POST
    REPLY_SAVE: "/business/notice/reply-save", // Added for POST
    REPLY: "/business/notice/reply", // Added for GET
    ALBUM_LIST: "/business/notice/album-list",
    TEMP_DETAIL: "/business/notice/temp-detail",
    HAS_NEW_REPLY: "/business/notice/has/new-reply",
  },
  BUSINESS_DIARY: {
    STYLE_STATUS: "/business/diary/style/status",
    STYLE_PRESETS: "/business/diary/style/presets",
    STYLE_LEARN: "/business/diary/style/learn",
    STYLE_SAMPLES: "/business/diary/style/samples",
    STYLE_SAMPLE_DELETE: (sampleSeq: number) =>
      `/business/diary/style/samples/${sampleSeq}`,
    STYLE_NOTICES: "/business/diary/style/notices",
    GENERATE: "/business/diary/generate",
    POLISH: "/business/diary/polish",
    BATCH: "/business/diary/batch",
  },
  BUSINESS_PHOTO: {
    FORM: "/business/photo/form",
    UPLOAD_POLICY: "/business/photo/upload-policy",
    ALBUM: "/business/photo/album",
    ALBUM_PAGE: "/business/photo/album/page",
    CREATE: "/business/photo",
    DELETE: "/business/photo",
    DOWNLOAD: "/business/photo/download",
  },
  BUSINESS_COMPANY_PHOTO: {
    LIST: "/business/mypage/company-photo-list",
    DETAIL: "/business/mypage/company-photo",
    CREATE: "/business/mypage/company-photo",
    DELETE: "/business/mypage/company-photo",
    REPRESENTATIVE: "/business/mypage/company-photo/representative",
    ORDER: "/business/mypage/company-photo/order",
    MEDIA: "/business/mypage/company-media",
  },
  BUSINESS_CREDIT: {
    WALLET: "/business/credit/wallet",
    TRANSACTIONS: "/business/credit/transactions",
    MONTHLY_SUMMARY: "/business/credit/monthly-summary",
    PACKAGES: "/business/credit/packages",
    CHECK_ACTION: "/business/credit/check-action",
  },
  BUSINESS_WALLET_CHARGE: {
    PRE_ORDER: "/business/wallet/charge/pre-order",
    CONFIRM: "/business/wallet/charge/confirm",
    ORDERS: "/business/wallet/charge/orders",
    ORDER_CANCEL: (orderId: string) =>
      `/business/wallet/charge/orders/${orderId}/cancel`,
  },
  BUSINESS_SEAL: {
    LIST: "/business/seal",
    CREATE: "/business/seal",
    DEFAULT: (sealSeq: number) => `/business/seal/${sealSeq}/default`,
    ACTIVE: (sealSeq: number) => `/business/seal/${sealSeq}/active`,
    DELETE: (sealSeq: number) => `/business/seal/${sealSeq}`,
    PIN_STATUS: "/business/seal/pin/status",
    PIN_SETUP: "/business/seal/pin",
    PIN_VERIFY: "/business/seal/pin/verify",
  },
  BUSINESS_CONTRACT_TEMPLATE: {
    LIST: "/business/contract/template",
    DETAIL: (contractSeq: number) =>
      `/business/contract/template/${contractSeq}`,
    CREATE: "/business/contract/template",
    UPDATE: (contractSeq: number) =>
      `/business/contract/template/${contractSeq}`,
    DELETE: (contractSeq: number) =>
      `/business/contract/template/${contractSeq}`,
    STATUS: (contractSeq: number) =>
      `/business/contract/template/${contractSeq}/status`,
    IMPORT_SOURCE: "/business/contract/template/import/source",
    IMPORT_AI: "/business/contract/template/import/ai",
  },
  BUSINESS_CONTRACT_REQUEST: {
    LIST: "/business/contract/request",
    DETAIL: (requestSeq: number) => `/business/contract/request/${requestSeq}`,
    SEND: "/business/contract/request",
    CANCEL: (requestSeq: number) =>
      `/business/contract/request/${requestSeq}/cancel`,
    RESEND: (requestSeq: number) =>
      `/business/contract/request/${requestSeq}/resend`,
  },
  USER_CONTRACT_REQUEST: {
    INBOX: "/user/contract/request",
    DETAIL: (requestSeq: number) => `/user/contract/request/${requestSeq}`,
    SIGN: "/user/contract/request/sign",
    REJECT: "/user/contract/request/reject",
    ATTACH: (requestSeq: number) =>
      `/user/contract/request/${requestSeq}/attach`,
    ENSURE: "/user/contract/request/ensure",
  },
  // 시스템 공지사항 (B/O에서 등록한 공지를 앱에서 조회)
  BUSINESS_ANNOUNCEMENT: {
    LIST: "/business/announcements",
    DETAIL: "/business/announcements", // + /{noticeSeq}
    UNREAD_COUNT: "/business/announcements/unread-count",
    READ: "/business/announcements", // POST + /{noticeSeq}/read
  },
  USER_ANNOUNCEMENT: {
    LIST: "/user/announcements",
    DETAIL: "/user/announcements", // + /{noticeSeq}
    UNREAD_COUNT: "/user/announcements/unread-count",
    READ: "/user/announcements", // POST + /{noticeSeq}/read
  },
  // 문의사항 (매장 상세 "정보 수정 및 제안")
  USER_INQUIRY: {
    CREATE: "/user/inquiries",
    LIST: "/user/inquiries", // GET — 내 문의 내역
  },
} as const;
